import { rnd2 } from "../Game";

export class ProtectedValue {
    private _offset: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    get value(): number { return this._offset + this._value; }
    set value(value: number) {
        this.setOffset();
        this._value = value - this._offset;
    }
    private _value: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(value: number = 0) {
        this.setOffset();
        this._value = value - this._offset;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    setToZero(): void {
        this.value = 0;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    add(value: number): number {
        value = this.value + value;
        this.value = value;

        return value;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    toString(): string {
        return this.value.toString();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private setOffset(): void {
        this._offset = rnd2.randomIntIn(0, Number.MAX_SAFE_INTEGER);
    }
}